import axios from 'axios';

import {
  ProductSearchRequest,
  ProductSearchResponse,
  Product,
  Gtin,
  CountryCode,
  ItemConfiguration,
  CreateItemConfigurationsRequest,
  CreateItemConfigurationsResponse,
} from './types';

export const api = axios.create({
  baseURL: process.env.PRODUCT_INFORMATION_SERVICE_URI,
});

export const searchProducts = async (countryCode: CountryCode, gtins: Gtin[]): Promise<Product[]> => {
  const request: ProductSearchRequest = { country: countryCode, gtins };
  const response = await api.post<ProductSearchResponse>('/v2/products/search', request);
  return response.data;
};

export const createItemConfigurations = async (
  itemConfigurations: ItemConfiguration[],
): Promise<ItemConfiguration[]> => {
  const request: CreateItemConfigurationsRequest = { itemConfigurations, publishMenuItemUpdates: true };
  const response = await api.put<CreateItemConfigurationsResponse>('/v2/item-source-configurations', request);
  return response.data.itemConfigurations;
};

export const deleteItemSourceConfigurationsForMenu = (menuId: string) =>
  api.delete('/v2/item-source-configurations', { data: { menu: menuId } });

export default api;
